import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getLang } from 'shared/store/selectors/lang.selector';
import { secondsUntilNextStep } from '../../helpers/use-totp-code';
import styles from './check-in.module.scss';

function formatCountdown(seconds) {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins}:${secs.toString().padStart(2, '0')}`;
}

export function CodeCountdown({ step, className }) {
  const lang = useSelector(getLang('CHECK_IN_ACTIVE'));
  const [remaining, setRemaining] = useState(() => secondsUntilNextStep(step));

  useEffect(() => {
    const id = setInterval(() => setRemaining(secondsUntilNextStep(step)), 1000);
    return () => clearInterval(id);
  }, [step]);

  return (
    <span className={className ?? styles.qrCountdown}>
      {lang.CODE_REFRESHES_IN.replace('{time}', formatCountdown(remaining))}
    </span>
  );
}
